import React from 'react';

const SvgWineGlass = (props) => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M8 22h8" />
    <path d="M12 11v11" />
    <path d="M5.7 3h12.6l-.9 7a5 5 0 01-5 4.5v0a5 5 0 01-5-4.5L5.7 3z" />
  </svg>
);

export default SvgWineGlass;
